function parseYoutubeUrl(url: string) {
  if (url) {
    let youtubeId = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    return youtubeId[2] !== undefined ? youtubeId[2].split(/[^0-9a-z_\\-]/i)[0] : youtubeId[0]
  }
}

export default parseYoutubeUrl